import React, { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import Tab, { TabGroup as TabGroupLib } from '@amzn/meridian/tab';
import { setSelectedTaskTab } from 'src/store/adminConfigPageSlice/adminConfigPageSlice';
import { AdminConfigNavConsts, AdminConfigTabMap } from 'src/store/adminConfigPageSlice/common/constants';
import { useAppSelector } from 'src/store/store';

// **** Components **** //

/**
 * Toggle the Task/TaskGroup Tables
 */
const TaskConfigurationTabs = () => {
  const { selectedTaskTab } = useAppSelector((state) => state.adminConfigPage);
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectTab = (newTab: string) => {
    dispatch(setSelectedTaskTab(newTab));
    const newPath = AdminConfigTabMap.TaskConfig.get(newTab);
    navigate(newPath, { replace: true });
  };

  // Set tab from URL, default to "Tasks" if none selected
  useEffect(() => {
    const tab = AdminConfigTabMap.TaskConfig.get(location.pathname);
    if (!!tab) {
      dispatch(setSelectedTaskTab(tab));
    } else if (location.pathname === AdminConfigNavConsts.Task.root.PATH) {
      selectTab(AdminConfigNavConsts.Task.Tasks.TAB);
    }
  }, [location.pathname]);

  return (
    <TabGroupLib value={selectedTaskTab} onChange={selectTab}>
      <Tab value={AdminConfigNavConsts.Task.Tasks.TAB}>Tasks</Tab>
      <Tab value={AdminConfigNavConsts.Task.TaskGroups.TAB}>Task Groups</Tab>
    </TabGroupLib>
  );
};

export default TaskConfigurationTabs;
